export class ValidateData{
    constructor(
        public code: string
    ){
        this.id = null;
        this.nameStyle = 0;
        this.codeStyle = 0;
    }
    public id: number;
    public name: string;
    public codeStyle: number;
    public nameStyle: number;
}



// WEBPACK FOOTER //
// ./src/app/stocks/models/validate-data.ts